<span #cellContent class="se-ui-datagrid-date_box" [matTooltipDisabled]="disabled" [matTooltip]="tooltipValue">
    {{ value()?.toDate() | date: viewFormat() }}
</span>
